import React, { Component } from "react"
import {
  Button,
  Select,
  Tag,
  Progress,
  Modal,
  Upload,
  Radio,
  InputNumber,
  Tabs,
  Table,
  Icon,
  Spin,
  message,
  Tooltip,
} from "antd"
import moment from "moment"
import * as Permissions from "../../services/permissions"
import {
  listRuns,
  getRun,
  createRun,
  pauseRun,
  resumeRun,
  getTemplate,
  listItems,
  listEvents,
  listFiles,
  listNotifications,
  markNotificationRead,
  listEmitidas,
  downloadTemplate,
  downloadDocs,
  downloadCompleto,
  getRequiredColumns,
} from "./services/nfePipeline.service"
import "./styles.css"

var Option = Select.Option
var Dragger = Upload.Dragger
var TabPane = Tabs.TabPane
var RadioGroup = Radio.Group

var STATUS_COLORS = {
  queued: "default",
  running: "processing",
  paused: "warning",
  completed: "success",
  failed: "error",
  canceled: "default",
  pending: "default",
  skipped: "default",
}

var STATUS_LABELS = {
  queued: "Na Fila",
  running: "Executando",
  paused: "Pausado",
  completed: "Concluído",
  failed: "Falhou",
  canceled: "Cancelado",
  pending: "Pendente",
  skipped: "Ignorado",
}

var STAGE_NAMES = {
  processar: "Emitir NF-e",
}

var STAGE_ICONS = {
  processar: "file-text",
}

var FILE_TYPE_ICONS = {
  input: "file-excel",
  planilha: "file-excel",
  log: "file-text",
  pdf: "file-pdf",
  xml: "file-code",
  snapshot: "camera",
  db: "database",
  report: "file",
  template: "file-excel",
}

var DEFAULT_PAGE_SIZE = 20

class NfePipelineView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      runs: [],
      selectedRunId: null,
      currentRun: null,
      loading: false,
      uploadModalVisible: false,
      uploadMode: "bradesco",
      uploadLimit: null,
      uploadImportEnabled: true,
      uploadFile: null,
      detailsModalVisible: false,
      selectedStage: null,
      stageItems: [],
      stageEvents: [],
      stageFiles: [],
      loadingDetails: false,
      stageItemsLoading: false,
      stageEventsLoading: false,
      stageFilesLoading: false,
      stageItemsPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
      stageEventsPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
      stageFilesPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
      notifications: [],
      loadingNotifications: false,
      emitidas: [],
      emitidasLoading: false,
      emitidasPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
      usingMockData: false,
      lastUpdatedAt: null,
      autoRefresh: true,
      refreshInterval: null,
      downloadingDocs: false,
      downloadingCompleto: false,
      requiredColumns: [],
      loadingRequiredColumns: false,
      uploadMissingColumns: [],
    }
  }

  renderEmptyState = (text) => {
    return React.createElement(
      "div",
      { className: "nfe-empty-state" },
      React.createElement(Icon, { type: "inbox", className: "nfe-empty-icon" }),
      React.createElement("div", { className: "nfe-empty-text" }, text),
    )
  }

  trackResponseMeta = (data) => {
    this.setState({
      usingMockData: Boolean(data && data.mock),
      lastUpdatedAt: new Date().toISOString(),
    })
  }

  getStageNameById = (stageId) => {
    if (!stageId || !this.state.currentRun || !this.state.currentRun.stages) return "-"
    var stage = this.state.currentRun.stages.find((item) => item.id === stageId)
    if (!stage) return "-"
    return STAGE_NAMES[stage.name] || stage.name
  }

  formatS3Key = (key) => {
    if (!key) return "-"
    var cleaned = key.replace(/^\/+/, "")
    var parts = cleaned.split("/")
    if (parts.length <= 3) return cleaned
    return parts.slice(parts.length - 3).join("/")
  }

  getRunProgress = (run) => {
    if (!run || !run.stages || run.stages.length === 0) return 0
    var visibleStages = this.getVisibleStages(run)
    var total = visibleStages.length
    if (total === 0) return 0
    var completed = visibleStages.filter((stage) => stage.status === "completed").length
    return Math.round((completed / total) * 100)
  }

  isStageVisibleForMode = (stageName, mode) => {
    return stageName === "processar"
  }

  getVisibleStages = (run) => {
    if (!run || !run.stages) return []
    return run.stages.filter((stage) => this.isStageVisibleForMode(stage.name, run.mode))
  }

  componentDidMount() {
    this.loadRuns()
    this.startAutoRefresh()
    this.loadEmitidas()
  }

  componentWillUnmount() {
    this.stopAutoRefresh()
  }

  startAutoRefresh = () => {
    var interval = setInterval(() => {
      if (this.state.autoRefresh && this.state.selectedRunId) {
        this.loadCurrentRun(false)
        this.loadNotifications()
      }
    }, 3000)
    this.setState({ refreshInterval: interval })
  }

  stopAutoRefresh = () => {
    if (this.state.refreshInterval) {
      clearInterval(this.state.refreshInterval)
      this.setState({ refreshInterval: null })
    }
  }

  loadRuns = () => {
    this.setState({ loading: true })
    listRuns({ page_size: 100 })
      .then((data) => {
        this.trackResponseMeta(data)
        var results = Array.isArray(data) ? data : data.results || []
        this.setState({
          runs: results,
          loading: false,
        })
        var selected = this.state.selectedRunId
        if (selected && !results.find((run) => run.id === selected)) {
          selected = null
        }
        if (results.length > 0 && !selected) {
          this.handleRunSelect(results[0].id)
        }
      })
      .catch((error) => {
        console.error("Error loading runs:", error)
        message.error("Erro ao carregar execuções")
        this.setState({ loading: false })
      })
  }

  loadCurrentRun = (showLoading) => {
    if (!this.state.selectedRunId) return

    if (showLoading !== false) {
      this.setState({ loading: true })
    }

    getRun(this.state.selectedRunId)
      .then((data) => {
        this.trackResponseMeta(data)
        this.setState({
          currentRun: data,
          loading: false,
        })
      })
      .catch((error) => {
        console.error("Error loading run:", error)
        message.error("Erro ao carregar execução")
        this.setState({ loading: false })
      })
  }

  handleRunSelect = (runId) => {
    this.setState({ selectedRunId: runId }, function () {
      this.loadCurrentRun()
      this.loadNotifications()
    })
  }

  handleRefresh = () => {
    this.loadRuns()
    if (this.state.selectedRunId) {
      this.loadCurrentRun()
      this.loadNotifications()
    }
    this.loadEmitidas()
  }

  handlePause = () => {
    if (!this.state.selectedRunId) return

    Modal.confirm({
      title: "Pausar Execução",
      content: "Deseja realmente pausar esta execução?",
      okText: "Pausar",
      cancelText: "Cancelar",
      onOk: () => {
        pauseRun(this.state.selectedRunId)
          .then(() => {
            message.success("Pausa solicitada com sucesso")
            this.loadCurrentRun()
          })
          .catch((error) => {
            console.error("Error pausing run:", error)
            message.error("Erro ao pausar execução")
          })
      },
    })
  }

  handleResume = () => {
    if (!this.state.selectedRunId) return

    resumeRun(this.state.selectedRunId)
      .then(() => {
        message.success("Execução retomada com sucesso")
        this.loadCurrentRun()
      })
      .catch((error) => {
        console.error("Error resuming run:", error)
        message.error("Erro ao retomar execução")
      })
  }

  loadNotifications = () => {
    if (!this.state.selectedRunId) return

    this.setState({ loadingNotifications: true })
    listNotifications({ run: this.state.selectedRunId, page_size: 20 })
      .then((data) => {
        this.trackResponseMeta(data)
        var results = Array.isArray(data) ? data : data.results || []
        this.setState({
          notifications: results,
          loadingNotifications: false,
        })
      })
      .catch((error) => {
        console.error("Error loading notifications:", error)
        this.setState({ loadingNotifications: false })
      })
  }

  loadEmitidas = (page, pageSize) => {
    var currentPage = page || this.state.emitidasPagination.current || 1
    var currentSize = pageSize || this.state.emitidasPagination.pageSize || DEFAULT_PAGE_SIZE
    this.setState({ emitidasLoading: true })
    listEmitidas({ page: currentPage, page_size: currentSize })
      .then((data) => {
        this.trackResponseMeta(data)
        var results = Array.isArray(data) ? data : data.results || []
        this.setState({
          emitidas: results,
          emitidasLoading: false,
          emitidasPagination: {
            current: currentPage,
            pageSize: currentSize,
            total: data && typeof data.count === "number" ? data.count : results.length,
          },
        })
      })
      .catch((error) => {
        console.error("Error loading emitidas:", error)
        this.setState({ emitidasLoading: false })
      })
  }

  handleNotificationRead = (notificationId) => {
    markNotificationRead(notificationId)
      .then(() => {
        var updated = this.state.notifications.map((item) => {
          if (item.id !== notificationId) return item
          return Object.assign({}, item, { read_at: new Date().toISOString() })
        })
        this.setState({ notifications: updated })
      })
      .catch((error) => {
        console.error("Error marking notification read:", error)
        message.error("Erro ao atualizar notificação")
      })
  }

  loadRequiredColumns = (mode) => {
    if (!mode) return
    this.setState({ loadingRequiredColumns: true, requiredColumns: [], uploadMissingColumns: [] })
    getRequiredColumns(mode)
      .then((data) => {
        this.trackResponseMeta(data)
        var columns = (data && data.required_columns) || []
        this.setState({
          requiredColumns: columns,
          loadingRequiredColumns: false,
        })
      })
      .catch((error) => {
        console.error("Error loading required columns:", error)
        message.error("Erro ao carregar colunas obrigatorias")
        this.setState({ loadingRequiredColumns: false, requiredColumns: [] })
      })
  }

  handleUpload = () => {
    if (!Permissions.hasExplicit(Permissions.NFE_VIEWER)) {
      message.warning("Você não possui permissão para iniciar a emissão de NFe")
      return
    }
    this.setState({ uploadModalVisible: true }, () => {
      this.loadRequiredColumns(this.state.uploadMode)
    })
  }

  handleUploadCancel = () => {
    this.setState({
      uploadModalVisible: false,
      uploadFile: null,
      uploadMode: "bradesco",
      uploadLimit: null,
      uploadImportEnabled: true,
      requiredColumns: [],
      uploadMissingColumns: [],
      loadingRequiredColumns: false,
    })
  }

  handleUploadSubmit = () => {
    if (!this.state.uploadFile) {
      message.warning("Selecione um arquivo")
      return
    }

    this.setState({ loading: true, uploadMissingColumns: [] })

    createRun(this.state.uploadFile, this.state.uploadMode, this.state.uploadLimit)
      .then((data) => {
        message.success("Pipeline iniciado com sucesso")
        this.setState({
          uploadModalVisible: false,
          uploadFile: null,
          uploadImportEnabled: true,
          loading: false,
        })
        this.loadRuns()
        this.handleRunSelect(data.id)
      })
      .catch((error) => {
        console.error("Error creating run:", error)
        var data = error && error.response && error.response.data
        var missing = data && data.missing_columns
        if (Array.isArray(missing) && missing.length > 0) {
          message.error("Planilha sem todas as colunas obrigatorias")
          this.setState({
            uploadMissingColumns: missing,
            requiredColumns: data.required_columns || this.state.requiredColumns,
            loading: false,
          })
        } else {
          message.error("Erro ao iniciar pipeline")
          this.setState({ loading: false })
        }
      })
  }

  handleDownloadTemplate = () => {
    var mode = this.state.uploadMode

    downloadTemplate(mode)
      .then((data) => {
        var blob = data && data.blob ? data.blob : null
        if (!blob) {
          message.error("Template indisponivel")
          return
        }
        var filename = (data && data.filename) || mode.toUpperCase() + "_TEMPLATE.xlsx"
        var url = window.URL.createObjectURL(blob)
        var link = document.createElement("a")
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        message.success("Template disponível para download")
      })
      .catch((error) => {
        console.error("Error downloading template:", error)
        message.error("Erro ao baixar template")
      })
  }

  handleDownloadDocs = () => {
    if (!this.state.selectedRunId) return

    this.setState({ downloadingDocs: true })
    downloadDocs(this.state.selectedRunId)
      .then((data) => {
        var blob = data && data.blob ? data.blob : null
        if (!blob) {
          message.error("Nenhum arquivo disponivel para download")
          return
        }
        var filename = (data && data.filename) || "nfe_docs.zip"
        var url = window.URL.createObjectURL(blob)
        var link = document.createElement("a")
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      .catch((error) => {
        console.error("Error downloading docs:", error)
        message.error("Erro ao baixar notas")
      })
      .finally(() => {
        this.setState({ downloadingDocs: false })
      })
  }

  handleDownloadCompleto = () => {
    if (!this.state.selectedRunId) return

    this.setState({ downloadingCompleto: true })
    downloadCompleto(this.state.selectedRunId)
      .then((data) => {
        var blob = data && data.blob ? data.blob : null
        if (!blob) {
          message.error("Nenhum arquivo disponivel para download completo")
          return
        }
        var filename = (data && data.filename) || "nfe_completo.zip"
        var url = window.URL.createObjectURL(blob)
        var link = document.createElement("a")
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      .catch((error) => {
        console.error("Error downloading completo:", error)
        message.error("Erro ao baixar download completo")
      })
      .finally(() => {
        this.setState({ downloadingCompleto: false })
      })
  }

  loadStageItems = (stage, page, pageSize) => {
    if (!this.state.currentRun || !stage) return Promise.resolve()
    var runId = this.state.currentRun.id
    var stageId = stage.id

    this.setState({ stageItemsLoading: true })
    return listItems({ run: runId, stage: stageId, page: page, page_size: pageSize })
      .then((data) => {
        this.trackResponseMeta(data)
        var results = Array.isArray(data) ? data : data.results || []
        this.setState({
          stageItems: results,
          stageItemsLoading: false,
          stageItemsPagination: {
            current: page,
            pageSize: pageSize,
            total: data.count || results.length,
          },
        })
      })
      .catch((error) => {
        console.error("Error loading stage items:", error)
        message.error("Erro ao carregar itens da etapa")
        this.setState({ stageItemsLoading: false })
      })
  }

  loadStageEvents = (stage, page, pageSize) => {
    if (!this.state.currentRun || !stage) return Promise.resolve()
    var runId = this.state.currentRun.id
    var stageId = stage.id

    this.setState({ stageEventsLoading: true })
    return listEvents({ run: runId, stage: stageId, page: page, page_size: pageSize })
      .then((data) => {
        this.trackResponseMeta(data)
        var results = Array.isArray(data) ? data : data.results || []
        this.setState({
          stageEvents: results,
          stageEventsLoading: false,
          stageEventsPagination: {
            current: page,
            pageSize: pageSize,
            total: data.count || results.length,
          },
        })
      })
      .catch((error) => {
        console.error("Error loading stage events:", error)
        message.error("Erro ao carregar eventos da etapa")
        this.setState({ stageEventsLoading: false })
      })
  }

  loadStageFiles = (stage, page, pageSize) => {
    if (!this.state.currentRun || !stage) return Promise.resolve()
    var runId = this.state.currentRun.id
    var stageId = stage.id

    this.setState({ stageFilesLoading: true })
    return listFiles({ run: runId, stage: stageId, page: page, page_size: pageSize })
      .then((data) => {
        this.trackResponseMeta(data)
        var results = Array.isArray(data) ? data : data.results || []
        this.setState({
          stageFiles: results,
          stageFilesLoading: false,
          stageFilesPagination: {
            current: page,
            pageSize: pageSize,
            total: data.count || results.length,
          },
        })
      })
      .catch((error) => {
        console.error("Error loading stage files:", error)
        message.error("Erro ao carregar arquivos da etapa")
        this.setState({ stageFilesLoading: false })
      })
  }

  handleStageClick = (stage) => {
    this.setState({
      selectedStage: stage,
      detailsModalVisible: true,
      loadingDetails: true,
      stageItems: [],
      stageEvents: [],
      stageFiles: [],
      stageItemsPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
      stageEventsPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
      stageFilesPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
    })

    Promise.all([
      this.loadStageItems(stage, 1, DEFAULT_PAGE_SIZE),
      this.loadStageEvents(stage, 1, DEFAULT_PAGE_SIZE),
      this.loadStageFiles(stage, 1, DEFAULT_PAGE_SIZE),
    ])
      .then(() => {
        this.setState({ loadingDetails: false })
      })
      .catch((error) => {
        console.error("Error loading stage details:", error)
        message.error("Erro ao carregar detalhes da etapa")
        this.setState({ loadingDetails: false })
      })
  }

  handleDetailsModalClose = () => {
    this.setState({
      detailsModalVisible: false,
      selectedStage: null,
      stageItems: [],
      stageEvents: [],
      stageFiles: [],
      stageItemsPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
      stageEventsPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
      stageFilesPagination: {
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
      },
    })
  }

  getStageProgress = (stage) => {
    if (stage.total_items === 0) return 0
    return Math.round((stage.processed_items / stage.total_items) * 100)
  }

  formatDuration = (startedAt, finishedAt) => {
    if (!startedAt) return "-"
    var start = moment(startedAt)
    var end = finishedAt ? moment(finishedAt) : moment()
    var duration = moment.duration(end.diff(start))

    var hours = Math.floor(duration.asHours())
    var minutes = duration.minutes()
    var seconds = duration.seconds()

    if (hours > 0) {
      return hours + "h " + minutes + "m " + seconds + "s"
    } else if (minutes > 0) {
      return minutes + "m " + seconds + "s"
    } else {
      return seconds + "s"
    }
  }

  formatFileSize = (bytes) => {
    if (!bytes) return "-"
    if (bytes < 1024) return bytes + " B"
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB"
    return (bytes / (1024 * 1024)).toFixed(2) + " MB"
  }

  renderUploadModal = () => {
    var draggerProps = {
      name: "file",
      multiple: false,
      accept: ".xlsx",
      beforeUpload: (file) => {
        this.setState({ uploadFile: file })
        return false
      },
      onRemove: () => {
        this.setState({ uploadFile: null })
      },
      fileList: this.state.uploadFile ? [this.state.uploadFile] : [],
    }

    return React.createElement(
      Modal,
      {
        title: "Nova Execução de Pipeline",
        visible: this.state.uploadModalVisible,
        onCancel: this.handleUploadCancel,
        onOk: this.handleUploadSubmit,
        okText: "Iniciar",
        cancelText: "Cancelar",
        width: 600,
        className: "nfe-upload-modal",
      },
      React.createElement(
        "div",
        { style: { marginBottom: 16 } },
        React.createElement("div", { style: { marginBottom: 8, fontWeight: 500 } }, "Modo de Execução:"),
        React.createElement(
          RadioGroup,
          {
            value: this.state.uploadMode,
            onChange: (e) => {
              var mode = e.target.value
              this.setState({ uploadMode: mode }, () => {
                this.loadRequiredColumns(mode)
              })
            },
          },
          React.createElement(Radio, { value: "bradesco" }, "Bradesco"),
          React.createElement(Radio, { value: "pavcob" }, "Pavcob"),
          React.createElement(Radio, { value: "arruda", disabled: true }, "Arruda (em breve)"),
          React.createElement(Radio, { value: "debt", disabled: true }, "Debt (em breve)"),
        ),
      ),
      React.createElement(
        "div",
        { style: { marginBottom: 16 } },
        React.createElement(
          "div",
          { style: { marginBottom: 8, fontWeight: 500 } },
          "Colunas obrigatórias (por modo):",
        ),
        React.createElement(
          Spin,
          { spinning: this.state.loadingRequiredColumns, size: "small" },
          React.createElement(
            "div",
            {
              style: {
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                padding: "8px 11px",
                minHeight: 32,
                backgroundColor: "#fafafa",
              },
            },
            this.state.requiredColumns.length > 0
              ? this.state.requiredColumns.map((col) =>
                  React.createElement(Tag, { key: col, color: "blue", style: { marginBottom: 4 } }, col),
                )
              : React.createElement("span", { style: { color: "#bfbfbf" } }, "Nenhuma coluna carregada"),
          ),
        ),
        this.state.uploadMissingColumns && this.state.uploadMissingColumns.length > 0
          ? React.createElement(
              "div",
              { className: "nfe-upload-missing" },
              "Faltando: " + this.state.uploadMissingColumns.join(", "),
            )
          : null,
      ),
      React.createElement(
        "div",
        { style: { marginBottom: 16 } },
        React.createElement(
          "div",
          { style: { marginBottom: 8, fontWeight: 500 } },
          "Limite de Processamento (opcional):",
        ),
        React.createElement(InputNumber, {
          min: 1,
          placeholder: "Sem limite",
          value: this.state.uploadLimit,
          onChange: (value) => {
            this.setState({ uploadLimit: value })
          },
          style: { width: "100%" },
        }),
      ),
      React.createElement(
        "div",
        { style: { marginBottom: 16 } },
        React.createElement(
          Button,
          {
            type: "dashed",
            icon: "download",
            onClick: this.handleDownloadTemplate,
            block: true,
          },
          "Baixar Template " + this.state.uploadMode.toUpperCase(),
        ),
      ),
      React.createElement(
        Dragger,
        draggerProps,
        React.createElement(
          "p",
          { className: "ant-upload-drag-icon" },
          React.createElement(Icon, { type: "inbox", className: "nfe-upload-icon" }),
        ),
        React.createElement("p", { className: "ant-upload-text" }, "Clique ou arraste o arquivo Excel"),
        React.createElement("p", { className: "ant-upload-hint" }, "Apenas arquivos .xlsx são aceitos"),
      ),
    )
  }

  renderStageSummaryItem = (label, value) => {
    return React.createElement(
      "div",
      { className: "nfe-stage-summary-item" },
      React.createElement("div", { className: "nfe-stage-summary-label" }, label),
      React.createElement("div", { className: "nfe-stage-summary-value" }, value),
    )
  }

  renderEmitidasSection = () => {
    var columns = [
      {
        title: "Data Emissão",
        dataIndex: "data_emissao",
        key: "data_emissao",
        width: 140,
        render: (value) => (value ? moment(value).format("DD/MM/YYYY") : "-"),
      },
      {
        title: "Tomador",
        dataIndex: "tomador_cpf_cnpj",
        key: "tomador_cpf_cnpj",
        width: 160,
      },
      {
        title: "Documento",
        dataIndex: "documento",
        key: "documento",
        width: 160,
      },
      {
        title: "Valor",
        dataIndex: "valor",
        key: "valor",
        width: 120,
        render: (value) => (value != null ? "R$ " + Number(value).toFixed(2) : "-"),
      },
      {
        title: "Modo",
        dataIndex: "mode",
        key: "mode",
        width: 110,
        render: (value) => (value ? String(value).toUpperCase() : "-"),
      },
      {
        title: "Run",
        dataIndex: "run",
        key: "run",
        width: 80,
        render: (value) => (value ? "#" + value : "-"),
      },
      {
        title: "Solicitado Por",
        dataIndex: "requested_by_username",
        key: "requested_by_username",
        width: 160,
        render: (value) => value || "-",
      },
      {
        title: "Situação",
        dataIndex: "situacao",
        key: "situacao",
        width: 160,
        render: (value) => value || "-",
      },
    ]

    return React.createElement(
      "div",
      { className: "nfe-emitidas-section" },
      React.createElement("div", { className: "nfe-emitidas-title" }, "Notas emitidas"),
      React.createElement(Table, {
        columns: columns,
        dataSource: this.state.emitidas,
        rowKey: "id",
        loading: this.state.emitidasLoading,
        pagination: {
          current: this.state.emitidasPagination.current,
          pageSize: this.state.emitidasPagination.pageSize,
          total: this.state.emitidasPagination.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => this.loadEmitidas(page, pageSize),
          onShowSizeChange: (page, pageSize) => this.loadEmitidas(page, pageSize),
        },
        size: "small",
      }),
    )
  }

  renderStageSummary = (stage) => {
    if (!stage) return null

    var checkpoint =
      stage.checkpoint && Object.keys(stage.checkpoint).length > 0 ? JSON.stringify(stage.checkpoint, null, 2) : null

    return React.createElement(
      "div",
      { className: "nfe-stage-summary" },
      React.createElement(
        "div",
        { className: "nfe-stage-summary-grid" },
        this.renderStageSummaryItem(
          "Status",
          React.createElement(Tag, { color: STATUS_COLORS[stage.status] }, STATUS_LABELS[stage.status] || stage.status),
        ),
        this.renderStageSummaryItem("Total", stage.total_items),
        this.renderStageSummaryItem("Processados", stage.processed_items),
        this.renderStageSummaryItem("Sucesso", stage.success_items),
        this.renderStageSummaryItem("Erros", stage.error_items),
        this.renderStageSummaryItem("Ignorados", stage.skipped_items),
        this.renderStageSummaryItem(
          "Inicio",
          stage.started_at ? moment(stage.started_at).format("DD/MM/YYYY HH:mm:ss") : "-",
        ),
        this.renderStageSummaryItem(
          "Fim",
          stage.finished_at ? moment(stage.finished_at).format("DD/MM/YYYY HH:mm:ss") : "-",
        ),
        this.renderStageSummaryItem(
          "Duracao",
          stage.started_at ? this.formatDuration(stage.started_at, stage.finished_at) : "-",
        ),
      ),
      stage.error_message &&
        React.createElement(
          "div",
          { className: "nfe-stage-summary-error" },
          React.createElement(Icon, { type: "exclamation-circle", style: { marginRight: 8 } }),
          stage.error_message,
        ),
      React.createElement(
        "div",
        null,
        React.createElement("div", { className: "nfe-stage-summary-label" }, "Checkpoint"),
        checkpoint
          ? React.createElement("pre", { className: "nfe-stage-checkpoint" }, checkpoint)
          : React.createElement("div", { className: "nfe-stage-checkpoint-empty" }, "Nenhum checkpoint registrado"),
      ),
    )
  }

  renderStageDetailsModal = () => {
    var stage = this.state.selectedStage

    if (!stage) return null

    var itemColumns = [
      {
        title: "Item",
        dataIndex: "item_key",
        key: "item_key",
        width: 200,
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 120,
        render: (status) =>
          React.createElement(
            Tag,
            {
              color: STATUS_COLORS[status],
              className: "nfe-item-status-tag",
            },
            STATUS_LABELS[status] || status,
          ),
      },
      {
        title: "Mensagem",
        dataIndex: "message",
        key: "message",
      },
      {
        title: "Detalhes",
        dataIndex: "metadata",
        key: "metadata",
        width: 120,
        render: (metadata) => {
          if (!metadata || Object.keys(metadata).length === 0) return "-"
          return React.createElement(
            Tooltip,
            { title: JSON.stringify(metadata) },
            React.createElement(Icon, { type: "info-circle" }),
          )
        },
      },
      {
        title: "Atualizado",
        dataIndex: "updated_at",
        key: "updated_at",
        width: 180,
        render: (date) => moment(date).format("DD/MM/YYYY HH:mm:ss"),
      },
    ]

    return React.createElement(
      Modal,
      {
        title: STAGE_NAMES[stage.name] || stage.name,
        visible: this.state.detailsModalVisible,
        onCancel: this.handleDetailsModalClose,
        footer: [React.createElement(Button, { key: "close", onClick: this.handleDetailsModalClose }, "Fechar")],
        width: 1000,
        className: "nfe-stage-details-modal",
      },
      this.state.loadingDetails
        ? React.createElement(
            "div",
            { style: { textAlign: "center", padding: 48 } },
            React.createElement(Spin, { size: "large" }),
          )
        : React.createElement(
            Tabs,
            { defaultActiveKey: "summary" },
            React.createElement(TabPane, { tab: "Resumo", key: "summary" }, this.renderStageSummary(stage)),
            React.createElement(
              TabPane,
              {
                tab: "Items (" + (this.state.stageItemsPagination.total || this.state.stageItems.length) + ")",
                key: "items",
              },
              this.state.stageItems.length > 0
                ? React.createElement(Table, {
                    columns: itemColumns,
                    dataSource: this.state.stageItems,
                    rowKey: "id",
                    pagination: {
                      current: this.state.stageItemsPagination.current,
                      pageSize: this.state.stageItemsPagination.pageSize,
                      total: this.state.stageItemsPagination.total,
                      showSizeChanger: true,
                      onChange: (page, pageSize) => {
                        this.loadStageItems(stage, page, pageSize)
                      },
                      onShowSizeChange: (page, pageSize) => {
                        this.loadStageItems(stage, page, pageSize)
                      },
                    },
                    size: "small",
                    loading: this.state.stageItemsLoading,
                  })
                : this.renderEmptyState("Nenhum item encontrado"),
            ),
            React.createElement(
              TabPane,
              {
                tab: "Eventos (" + (this.state.stageEventsPagination.total || this.state.stageEvents.length) + ")",
                key: "events",
              },
              this.state.stageEvents.length > 0
                ? React.createElement(Table, {
                    columns: [
                      {
                        title: "Nivel",
                        dataIndex: "level",
                        key: "level",
                        width: 120,
                        render: (level) => {
                          var label = level ? level.toUpperCase() : "-"
                          return React.createElement(
                            Tag,
                            { color: level === "error" ? "error" : level === "warning" ? "warning" : "processing" },
                            label,
                          )
                        },
                      },
                      {
                        title: "Mensagem",
                        dataIndex: "message",
                        key: "message",
                      },
                      {
                        title: "Detalhes",
                        dataIndex: "metadata",
                        key: "metadata",
                        width: 120,
                        render: (metadata) => {
                          if (!metadata || Object.keys(metadata).length === 0) return "-"
                          return React.createElement(
                            Tooltip,
                            { title: JSON.stringify(metadata) },
                            React.createElement(Icon, { type: "info-circle" }),
                          )
                        },
                      },
                      {
                        title: "Criado em",
                        dataIndex: "created_at",
                        key: "created_at",
                        width: 180,
                        render: (date) => moment(date).format("DD/MM/YYYY HH:mm:ss"),
                      },
                    ],
                    dataSource: this.state.stageEvents,
                    rowKey: "id",
                    pagination: {
                      current: this.state.stageEventsPagination.current,
                      pageSize: this.state.stageEventsPagination.pageSize,
                      total: this.state.stageEventsPagination.total,
                      showSizeChanger: true,
                      onChange: (page, pageSize) => {
                        this.loadStageEvents(stage, page, pageSize)
                      },
                      onShowSizeChange: (page, pageSize) => {
                        this.loadStageEvents(stage, page, pageSize)
                      },
                    },
                    size: "small",
                    loading: this.state.stageEventsLoading,
                  })
                : this.renderEmptyState("Nenhum evento encontrado"),
            ),
            React.createElement(
              TabPane,
              {
                tab: "Arquivos (" + (this.state.stageFilesPagination.total || this.state.stageFiles.length) + ")",
                key: "files",
              },
              this.state.stageFiles.length > 0
                ? React.createElement(Table, {
                    columns: [
                      {
                        title: "Arquivo",
                        dataIndex: "filename",
                        key: "filename",
                        render: (value, record) =>
                          React.createElement(
                            "div",
                            { className: "nfe-file-info" },
                            React.createElement(Icon, {
                              type: FILE_TYPE_ICONS[record.file_type] || "file",
                              className: "nfe-file-icon",
                            }),
                            React.createElement(
                              "div",
                              { className: "nfe-file-details" },
                              React.createElement(
                                Tooltip,
                                { title: record.s3_key || value },
                                React.createElement("div", { className: "nfe-file-name" }, value || record.s3_key),
                              ),
                              React.createElement(
                                "div",
                                { className: "nfe-file-meta" },
                                record.file_type +
                                  " • " +
                                  this.formatFileSize(record.size_bytes) +
                                  " • " +
                                  moment(record.created_at).format("DD/MM/YYYY HH:mm:ss"),
                              ),
                            ),
                          ),
                      },
                      {
                        title: "S3",
                        dataIndex: "s3_key",
                        key: "s3_key",
                        render: (key) => this.formatS3Key(key),
                      },
                    ],
                    dataSource: this.state.stageFiles,
                    rowKey: "id",
                    pagination: {
                      current: this.state.stageFilesPagination.current,
                      pageSize: this.state.stageFilesPagination.pageSize,
                      total: this.state.stageFilesPagination.total,
                      showSizeChanger: true,
                      onChange: (page, pageSize) => {
                        this.loadStageFiles(stage, page, pageSize)
                      },
                      onShowSizeChange: (page, pageSize) => {
                        this.loadStageFiles(stage, page, pageSize)
                      },
                    },
                    size: "small",
                    loading: this.state.stageFilesLoading,
                  })
                : this.renderEmptyState("Nenhum arquivo encontrado"),
            ),
          ),
    )
  }

  renderStageCard = (stage, index) => {
    var progress = this.getStageProgress(stage)
    var statusClass = "status-" + stage.status

    return React.createElement(
      "div",
      {
        key: stage.id,
        className: "nfe-stage-card " + statusClass,
        onClick: () => {
          this.handleStageClick(stage)
        },
      },
      React.createElement(
        "div",
        { className: "nfe-stage-header" },
        React.createElement(
          "div",
          { className: "nfe-stage-name" },
          React.createElement(Icon, {
            type: STAGE_ICONS[stage.name] || "file",
            className: "nfe-stage-icon",
          }),
          React.createElement("span", null, STAGE_NAMES[stage.name] || stage.name),
        ),
        React.createElement(Tag, { color: STATUS_COLORS[stage.status] }, STATUS_LABELS[stage.status] || stage.status),
      ),
      stage.total_items > 0 &&
        React.createElement(
          "div",
          { className: "nfe-stage-progress" },
          React.createElement(Progress, {
            percent: progress,
            status: stage.status === "failed" ? "exception" : stage.status === "completed" ? "success" : "active",
            strokeColor: stage.status === "running" ? "#1890ff" : undefined,
          }),
        ),
      stage.total_items > 0 &&
        React.createElement(
          "div",
          { className: "nfe-stage-stats" },
          React.createElement(
            "div",
            { className: "nfe-stage-stat" },
            React.createElement("div", { className: "nfe-stage-stat-label" }, "Total"),
            React.createElement("div", { className: "nfe-stage-stat-value" }, stage.total_items),
          ),
          React.createElement(
            "div",
            { className: "nfe-stage-stat" },
            React.createElement("div", { className: "nfe-stage-stat-label" }, "Processados"),
            React.createElement("div", { className: "nfe-stage-stat-value" }, stage.processed_items),
          ),
          stage.success_items > 0 &&
            React.createElement(
              "div",
              { className: "nfe-stage-stat" },
              React.createElement("div", { className: "nfe-stage-stat-label" }, "Sucesso"),
              React.createElement("div", { className: "nfe-stage-stat-value success" }, stage.success_items),
            ),
          stage.error_items > 0 &&
            React.createElement(
              "div",
              { className: "nfe-stage-stat" },
              React.createElement("div", { className: "nfe-stage-stat-label" }, "Erros"),
              React.createElement("div", { className: "nfe-stage-stat-value error" }, stage.error_items),
            ),
          stage.skipped_items > 0 &&
            React.createElement(
              "div",
              { className: "nfe-stage-stat" },
              React.createElement("div", { className: "nfe-stage-stat-label" }, "Ignorados"),
              React.createElement("div", { className: "nfe-stage-stat-value skipped" }, stage.skipped_items),
            ),
        ),
      (stage.started_at || stage.finished_at) &&
        React.createElement(
          "div",
          { className: "nfe-stage-times" },
          stage.started_at &&
            React.createElement(
              "div",
              { className: "nfe-stage-time" },
              React.createElement(Icon, { type: "clock-circle" }),
              React.createElement("span", null, "Iniciado: " + moment(stage.started_at).format("DD/MM HH:mm:ss")),
            ),
          stage.finished_at &&
            React.createElement(
              "div",
              { className: "nfe-stage-time" },
              React.createElement(Icon, { type: "check-circle" }),
              React.createElement("span", null, "Duração: " + this.formatDuration(stage.started_at, stage.finished_at)),
            ),
        ),
      stage.error_message &&
        React.createElement(
          "div",
          {
            style: {
              marginTop: 12,
              padding: "8px 12px",
              background: "#fff2e8",
              borderRadius: 4,
              fontSize: 12,
              color: "#d4380d",
            },
          },
          React.createElement(Icon, { type: "exclamation-circle", style: { marginRight: 8 } }),
          stage.error_message,
        ),
    )
  }

  render() {
    // Guard de acesso: verifica se o usuário possui permissão
    if (!Permissions.hasExplicit(Permissions.NFE_VIEWER)) {
      return React.createElement(
        "div",
        { className: "nfe-pipeline-container" },
        React.createElement("h2", null, "Acesso Negado"),
        React.createElement("p", null, "Você não possui permissão para acessar a emissão de NFe."),
        React.createElement("p", null, "Entre em contato com o administrador para solicitar acesso."),
      )
    }

    var run = this.state.currentRun
    var runConfig = run && run.run_config ? run.run_config : {}
    var allStages = run && run.stages ? run.stages.slice().sort((a, b) => a.order - b.order) : []
    var stages = run ? this.getVisibleStages(run).sort((a, b) => a.order - b.order) : []
    var totalStages = stages.length
    var completedStages = stages.filter((stage) => stage.status === "completed").length
    var runProgress = run ? this.getRunProgress(run) : 0

    return React.createElement(
      "div",
      { className: "nfe-pipeline-view" },
      React.createElement(
        "div",
        { className: "nfe-pipeline-header" },
        React.createElement(
          "div",
          { className: "nfe-pipeline-title-wrapper" },
          React.createElement("h1", { className: "nfe-pipeline-title" }, "Emissão NFe"),
          this.state.usingMockData && React.createElement(Tag, { className: "nfe-mock-tag" }, "Mock"),
        ),
        React.createElement(
          "div",
          { className: "nfe-pipeline-actions" },
          this.state.lastUpdatedAt &&
            React.createElement(
              "div",
              { className: "nfe-refresh-indicator" },
              React.createElement(Icon, { type: "clock-circle" }),
              "Atualizado " + moment(this.state.lastUpdatedAt).format("HH:mm:ss"),
            ),
          React.createElement(
            Tooltip,
            { title: this.state.autoRefresh ? "Auto-refresh ativado" : "Auto-refresh desativado" },
            React.createElement(
              Button,
              {
                icon: this.state.autoRefresh ? "pause-circle" : "play-circle",
                onClick: () => {
                  this.setState({ autoRefresh: !this.state.autoRefresh })
                },
              },
              this.state.autoRefresh ? "Pausar" : "Retomar",
            ),
          ),
          React.createElement(Button, { icon: "reload", onClick: this.handleRefresh }, "Atualizar"),
          React.createElement(
            Tooltip,
            { title: Permissions.hasExplicit(Permissions.NFE_VIEWER) ? "" : "Você não possui permissão para iniciar a emissão" },
            React.createElement(
              Button,
              { type: "primary", icon: "upload", onClick: this.handleUpload, disabled: !Permissions.hasExplicit(Permissions.NFE_VIEWER) },
              "Nova Execução",
            ),
          ),
        ),
      ),
      React.createElement(
        "div",
        { className: "nfe-pipeline-content" },
        React.createElement(
          "div",
          { className: "nfe-run-selector" },
          React.createElement("div", { className: "nfe-run-selector-title" }, "Selecionar Execução:"),
          React.createElement(
            Select,
            {
              value: this.state.selectedRunId,
              onChange: this.handleRunSelect,
              style: { width: "100%" },
              placeholder: "Selecione uma execução",
              loading: this.state.loading && this.state.runs.length === 0,
            },
            this.state.runs.map((r) =>
              React.createElement(
                Option,
                { key: r.id, value: r.id },
                "Run #" +
                  r.id +
                  " - " +
                  r.input_name +
                  " (" +
                  (STATUS_LABELS[r.status] || r.status) +
                  ") - " +
                  moment(r.created_at).format("DD/MM/YYYY HH:mm"),
              ),
            ),
          ),
        ),
        run &&
          React.createElement(
            "div",
            { className: "nfe-run-info" },
            React.createElement(
              "div",
              { className: "nfe-run-info-header" },
              React.createElement("div", { className: "nfe-run-info-title" }, "Informações da Execução"),
              React.createElement(
                "div",
                { style: { display: "flex", gap: 8 } },
                React.createElement(
                  Button,
                  {
                    icon: "download",
                    onClick: this.handleDownloadDocs,
                    size: "small",
                    loading: this.state.downloadingDocs,
                  },
                  "Baixar notas",
                ),
                React.createElement(
                  Button,
                  {
                    icon: "download",
                    onClick: this.handleDownloadCompleto,
                    size: "small",
                    loading: this.state.downloadingCompleto,
                  },
                  "Download Completo",
                ),
                Permissions.hasExplicit(Permissions.NFE_VIEWER) &&
                  (run.status === "running" || run.status === "queued") &&
                  !run.pause_requested &&
                  React.createElement(Button, { icon: "pause", onClick: this.handlePause, size: "small" }, "Pausar"),
                Permissions.hasExplicit(Permissions.NFE_VIEWER) &&
                  run.status === "paused" &&
                  React.createElement(
                    Button,
                    { icon: "play-circle", onClick: this.handleResume, type: "primary", size: "small" },
                    "Retomar",
                  ),
              ),
            ),
            React.createElement(
              "div",
              { className: "nfe-run-info-meta" },
              React.createElement(
                "div",
                { className: "nfe-run-meta-item" },
                React.createElement("div", { className: "nfe-run-meta-label" }, "ID"),
                React.createElement("div", { className: "nfe-run-meta-value" }, "#" + run.id),
              ),
              React.createElement(
                "div",
                { className: "nfe-run-meta-item" },
                React.createElement("div", { className: "nfe-run-meta-label" }, "Status"),
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-value" },
                  React.createElement(
                    Tag,
                    { color: STATUS_COLORS[run.status] },
                    STATUS_LABELS[run.status] || run.status,
                  ),
                ),
              ),
              React.createElement(
                "div",
                { className: "nfe-run-meta-item" },
                React.createElement("div", { className: "nfe-run-meta-label" }, "Modo"),
                React.createElement("div", { className: "nfe-run-meta-value" }, (run.mode || "-").toUpperCase()),
              ),
              typeof runConfig.import_enabled === "boolean" &&
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-item" },
                  React.createElement("div", { className: "nfe-run-meta-label" }, "Importacao"),
                  React.createElement(
                    "div",
                    { className: "nfe-run-meta-value" },
                    runConfig.import_enabled ? "Ativa" : "Desativada",
                  ),
                ),
              React.createElement(
                "div",
                { className: "nfe-run-meta-item" },
                React.createElement("div", { className: "nfe-run-meta-label" }, "Arquivo"),
                React.createElement("div", { className: "nfe-run-meta-value" }, run.input_name),
              ),
              run.current_planilha_s3_key &&
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-item" },
                  React.createElement("div", { className: "nfe-run-meta-label" }, "Planilha S3"),
                  React.createElement(
                    Tooltip,
                    { title: run.current_planilha_s3_key },
                    React.createElement(
                      "div",
                      { className: "nfe-run-meta-value nfe-s3-key" },
                      this.formatS3Key(run.current_planilha_s3_key),
                    ),
                  ),
                ),
              run.output_s3_key &&
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-item" },
                  React.createElement("div", { className: "nfe-run-meta-label" }, "Saida S3"),
                  React.createElement(
                    Tooltip,
                    { title: run.output_s3_key },
                    React.createElement(
                      "div",
                      { className: "nfe-run-meta-value nfe-s3-key" },
                      this.formatS3Key(run.output_s3_key),
                    ),
                  ),
                ),
              React.createElement(
                "div",
                { className: "nfe-run-meta-item" },
                React.createElement("div", { className: "nfe-run-meta-label" }, "Criado em"),
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-value" },
                  moment(run.created_at).format("DD/MM/YYYY HH:mm:ss"),
                ),
              ),
              run.started_at &&
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-item" },
                  React.createElement("div", { className: "nfe-run-meta-label" }, "Iniciado em"),
                  React.createElement(
                    "div",
                    { className: "nfe-run-meta-value" },
                    moment(run.started_at).format("DD/MM/YYYY HH:mm:ss"),
                  ),
                ),
              run.finished_at &&
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-item" },
                  React.createElement("div", { className: "nfe-run-meta-label" }, "Finalizado em"),
                  React.createElement(
                    "div",
                    { className: "nfe-run-meta-value" },
                    moment(run.finished_at).format("DD/MM/YYYY HH:mm:ss"),
                  ),
                ),
              run.started_at &&
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-item" },
                  React.createElement("div", { className: "nfe-run-meta-label" }, "Duração"),
                  React.createElement(
                    "div",
                    { className: "nfe-run-meta-value" },
                    this.formatDuration(run.started_at, run.finished_at),
                  ),
                ),
              run.limit &&
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-item" },
                  React.createElement("div", { className: "nfe-run-meta-label" }, "Limite"),
                  React.createElement("div", { className: "nfe-run-meta-value" }, run.limit),
                ),
              run.current_stage &&
                React.createElement(
                  "div",
                  { className: "nfe-run-meta-item" },
                  React.createElement("div", { className: "nfe-run-meta-label" }, "Etapa Atual"),
                  React.createElement(
                    "div",
                    { className: "nfe-run-meta-value" },
                    STAGE_NAMES[run.current_stage] || run.current_stage,
                  ),
                ),
            ),
            totalStages > 0 &&
              React.createElement(
                "div",
                { className: "nfe-run-progress" },
                React.createElement("div", { className: "nfe-run-progress-label" }, "Progresso do Pipeline"),
                React.createElement(Progress, {
                  percent: runProgress,
                  status: run.status === "failed" ? "exception" : run.status === "completed" ? "success" : "active",
                }),
                React.createElement(
                  "div",
                  { className: "nfe-run-progress-meta" },
                  completedStages + "/" + totalStages + " etapas concluidas",
                ),
              ),
            run.pause_requested &&
              React.createElement(
                "div",
                {
                  style: {
                    marginTop: 16,
                    padding: "12px 16px",
                    background: "#fff7e6",
                    border: "1px solid #ffd591",
                    borderRadius: 4,
                  },
                },
                React.createElement(Icon, { type: "pause-circle", style: { marginRight: 8, color: "#fa8c16" } }),
                React.createElement(
                  "span",
                  { style: { color: "#fa8c16", fontWeight: 500 } },
                  "Pausa solicitada - Pipeline será pausada após a conclusão da tarefa atual",
                ),
              ),
            run.error_message &&
              React.createElement(
                "div",
                {
                  style: {
                    marginTop: 16,
                    padding: "12px 16px",
                    background: "#fff2e8",
                    border: "1px solid #ffbb96",
                    borderRadius: 4,
                  },
                },
                React.createElement(Icon, { type: "close-circle", style: { marginRight: 8, color: "#ff4d4f" } }),
                React.createElement("span", { style: { color: "#d4380d" } }, run.error_message),
              ),
          ),
        run &&
          run.stages &&
          run.stages.length > 0 &&
          React.createElement(
            "div",
            { className: "nfe-pipeline-stages" },
            React.createElement("div", { className: "nfe-pipeline-stages-title" }, "Etapas do Pipeline"),
            React.createElement(
              "div",
              { className: "nfe-stages-container" },
              React.createElement("div", { className: "nfe-connector" }),
              stages.map((stage, index) => this.renderStageCard(stage, index)),
            ),
          ),
        this.renderEmitidasSection(),
        this.state.loading &&
          !run &&
          React.createElement(
            "div",
            { style: { textAlign: "center", padding: 48 } },
            React.createElement(Spin, { size: "large", tip: "Carregando..." }),
          ),
      ),
      this.renderUploadModal(),
      this.renderStageDetailsModal(),
    )
  }
}

export default NfePipelineView



// WEBPACK FOOTER //
// ./src/components/NFePipeline/index.jsx